import React from "react";
import {Link} from "gatsby";
import PlaceholderImage from "assets/images/thumbnail-portrait-generic.jpg";
import VideoPlaceholderImage from "assets/images/thumbnail-video-generic.jpeg";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import {Button, FlagCard, ExternalIcon } from "components/ui";

const isBrowser = typeof window !== "undefined";

const FlagCardContainer = ({title, resources, topicPage, ...rest}) => {
    let thisLocationPathname = ''
    if (isBrowser) {
        thisLocationPathname = window.location.pathname
    }
    let resourceList = topicPage? resources?.filter(resource=>{
        return (resource?.pdf && (resource?.series?.length < 1 || resource?.series === undefined )) || (resource?.video_url && ( resource?.series === undefined || resource?.videos_webinars_series?.length < 1 || resource?.series?.length < 1 )) || (resource?.external_url_resource && (resource?.series?.length < 1 || resource?.series === undefined )) || (resource?.external_url_resource && (resource?.videos_webinars_series?.length < 1 || resource?.series === undefined )) || (resource?.resources?.length > 0) || (resource?.videos_webinars_series?.length > 0 )
    }) : resources;
    (thisLocationPathname !=="/whats-new") && 
    (
        resourceList.sort((a, b) => {
            return Date.parse(b?.resource_date || b?.date)  - Date.parse(a?.resource_date || a?.date)})
    )
    const TraumaToolkitSeries = [
        "Part 1: Trauma-Informed Care Tip Sheet for Collaborative Teams Serving Children, Parents, and Family Members Affected by Substance Use and Co-occurring Mental Health Challenges", 
        "Part 2: Trauma-Informed Care Tutorial Video",
        "Part 3: Collaborative Trauma-Informed Care Tool"];
    (thisLocationPathname.includes("trauma-toolkit-series")) &&
    (
        resourceList.sort((a, b) => {
            return TraumaToolkitSeries.indexOf(a.title)  - TraumaToolkitSeries.indexOf(b.title)})
    )
    return (
        <div className={`${rest.containerPadding ? rest.containerPadding : "padding-y-5"} ${rest.containerStyle}`}>
            <div className="grid-container">
                {title && <h2 className={`${rest.headerColor}`}>{title}</h2> }
                <div className="usa-card-group">
                    {resourceList.map((resource, idx) => {
                    let resourceTitle = resource?.title;
                    let excerpt = resource?.body?.data?.childMarkdownRemark?.excerpt?.replace("…",'');
                    return (
                        <FlagCard key={`${rest.keyName}-${idx + 1}`}
                        grid={rest.grid}
                        background={rest.cardColor}
                        border={rest.border}>
                            <FlagCard.Header>
                            {resourceTitle &&
                                <h2 className="usa-card__heading">
                                    {resource?.video_url && (resourceTitle.length > 125 ? resourceTitle.substring(0,125) + "..." : resourceTitle)}
                                    {!resource?.video_url && (resourceTitle.length > 128 ? resourceTitle.substring(0,128) + "..." : resourceTitle)}
                                 </h2>
                            }
                            </FlagCard.Header>
                            <FlagCard.Media>
                            {resource?.thumbnail ?
                                <div className={`usa-card__img ${resource?.video_url || (resource?.videos_webinars_series?.length > 1  && resource.slug !== "ICWA-active-efforts-series") || (resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.width === 470 && resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.height < 300) ? "padding-top-3":""}`}>
                                    <GatsbyImage
                                        image={getImage(resource?.thumbnail?.localFile)}
                                        alt={resource?.thumbnail?.alternativeText ?? ""}
                                        imgStyle={{width: resource?.video_url || (resource?.videos_webinars_series?.length > 1 && resource.slug !== "ICWA-active-efforts-series") || (resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.width === 470 && resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.height < 300) ? "100%": "205px", height: resource?.video_url || (resource?.videos_webinars_series?.length > 1  && resource.slug !== "ICWA-active-efforts-series") || (resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.width === 470 && resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.height < 300) ? "100%" : "265px"}}
                                        style={{ width: `${resource?.video_url || (resource?.videos_webinars_series?.length > 1  && resource.slug !== "ICWA-active-efforts-series") || (resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.width === 470 && resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.height < 300) ? "215px" :"205px"}`, height: `${resource?.video_url || (resource?.videos_webinars_series?.length > 1  && resource.slug !== "ICWA-active-efforts-series") || (resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.width === 470 && resource?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData?.height < 300) ? "121px" : "267px"}`}}
                                    />
                                </div>
                            :
                            resource?.video_url ?
                                <div className="usa-card__img width-full padding-top-3">
                                    <img
                                    src={VideoPlaceholderImage}
                                    alt=""
                                    style={{width: "215px", height: "121px"}}
                                    />
                                </div>
                            :
                                <div className="usa-card__img width-full">
                                    <img
                                    src={PlaceholderImage}
                                    alt=""
                                    />
                                </div>
                            }
                            </FlagCard.Media>
                            <FlagCard.Body>
                                {resource?.video_url ?
                                    <>
                                        {resource?.date && <p>Date: {resource?.date.substring(0,70)}</p> }
                                        {resource?.body &&
                                        <>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                __html: excerpt,
                                                }}
                                                className="card-text"
                                            />...
                                            (<Link to={`/training/videos-and-webinars/${resource?.slug}`}>Read More</Link>)
                                        </>
                                        }
                                    </>
                                    :  <>
                                            <p>{`${resource?.author?.substring(0,70) ?? ''}${resource?.author ? (resource?.author?.length > 70 ? `..., `: `, `):""}`}{resource?.author && (resource?.resource_date?.slice(-4) ?? 'n.d.')}</p>
                                            {resource.body &&
                                            <>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                    __html: excerpt,
                                                    }}
                                                    className="card-text"
                                                />...
                                                {thisLocationPathname === "/training/videos-and-webinars/" ? 
                                                    <>(<Link to={resource?.resources || resource?.videos_webinars_series?.length > 0 ? `/topics/${resource.topics[0].slug}/${resource.slug}` : resource.slug}>Read More</Link>)</>
                                                :
                                                    <>(<Link to={`${resource?.slug}`}>Read More</Link>)</>
                                                }
                                            </>
                                            }
                                        </>
                                }
                            </FlagCard.Body>
                            <FlagCard.Footer cardFooter="mobile:margin-x-auto">
                                {resource?.pdf ?
                                <>
                                    {resource?.pdf?.name.includes(".zip") ?
                                        <a 
                                        href ={`/files/${resource?.pdf?.name}`} 
                                        aria-label={`Download ${resource.card_title}`} 
                                        className="usa-button primary-button padding-x-5" 
                                        target="_blank" 
                                        rel="noreferrer"
                                        >
                                            Download Resource{ ` (ZIP ${resource?.pdf?.localFile?.prettySize.toUpperCase()})`}
                                        </a>
                                    :
                                        <Button color="primary-button" size="padding-x-5" link={`/files/${resource?.pdf && resource?.pdf?.name}`} labelText={`Open ${resourceTitle} document in a new window`}>
                                            View Document { ` (PDF ${resource?.pdf?.localFile?.prettySize.toUpperCase()})`}
                                        </Button>
                                    }
                                    {resource?.external_resource && <ExternalIcon /> }
                                </>
                                :
                                resource?.video_url ?
                                <>
                                   <Button color="primary-button" type="button" size="padding-x-5" labelText={`Open ${resource?.title} Video in page`} onClick={rest.buttonOnClick} title={resource?.title}>
                                       Watch Video
                                    </Button>
                                    {resource?.external_resource && <ExternalIcon /> }
                                </>
                                :
                                resource?.external_url_resource ?
                                <>
                                    {resource?.external_file_size ?
                                        <a href={resource?.external_url_resource && resource?.external_url_resource} className="usa-button primary-button padding-x-5"  aria-label={`Open ${resource?.title} in a new window`} target="_blank" rel="noreferrer">
                                            View Document { resource?.external_file_size &&` (PDF ${resource?.external_file_size})`}
                                        </a>
                                    :
                                        <a href={resource?.external_url_resource && resource?.external_url_resource} className="usa-button primary-button padding-x-5"  aria-label={`Open ${resource?.title} in a new window`} target="_blank" rel="noreferrer">
                                            View Website
                                        </a>
                                    }
                                    {resource?.external_resource && <ExternalIcon />}
                                </>
                                :
                                thisLocationPathname === "/training/videos-and-webinars/" ?
                                <Button color="primary-button" type="button" size="padding-x-5" link={resource?.resources || resource?.videos_webinars_series?.length > 0 ? `/topics/${resource.topics[0].slug}/${resource.slug}` : resource.slug} labelText={`Learn more About ${resourceTitle}`}>
                                    {(resource?.resources || resource?.videos_webinars_series?.length > 0) ? 'View Series' : 'Learn More' }
                                </Button>
                                :
                                <>
                                <Button color="primary-button" type="button" size="padding-x-5" link={resource?.slug} labelText={`Learn more About ${resourceTitle}`}>
                                    {(resource?.resources || resource?.videos_webinars_series?.length > 0) ? 'View Series' : 'Learn More' }
                                </Button>
                                  {resource?.external_resource && <ExternalIcon /> }
                              </>
                            }
                            </FlagCard.Footer>
                        </FlagCard>
                    )
                    })}
                </div>
            </div>
        </div>
    )
}

export default FlagCardContainer;
